import "./../../bindings/bao-searcher";
import "./../../bindings/log";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import * as moment from "moment";
/**
 * Explorer - Billing - Quickfilter
 */
class ServiceComponentQuickFilter {
    /** Selected Month - default ist current month
     */
    Month = ko.observable(moment().format("M"));
    /** Selected Year - default ist current year
     */
    Year = ko.observable(moment().format("YYYY"));
    /** Available Years - last 15 years from now
     */
    YearOptions = ko.observableArray(function () {
        //hack get last 15 years
        let currentYear = Number(moment().format("YYYY"));
        let years = [];
        for (let i = 0; i < 15; i++)
            years.push(currentYear - (<any>i));
        return years;
    }());
    explorerViewModel;
    constructor(explorerViewModel: any) {
        this.explorerViewModel = explorerViewModel;
        this.Month.subscribe(() => {
            this.SetQuickFilterObject();
        });
        this.Year.subscribe(() => {
            this.SetQuickFilterObject();
        });
    }
    //functions
    SetQuickFilterObject() {
        this.explorerViewModel.QuickFilterJson(JSON.stringify({
            Month: this.Month(),
            Year: this.Year()
        }));
    }
    ;
    init() {
        return Bao.get("ServiceComponent/ExplorerQuickFilterTemplate")
            .then((template) => {
            var templateName = "ExplorerQuickFilter";
            Bao.Templates[templateName] = template;
            this.explorerViewModel.QuickFilterTemplateName(templateName);
            this.explorerViewModel.QuickFilter(this);
        });
    }
    ;
}
export default ServiceComponentQuickFilter;